const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "हमारा परिचय",
    "termsOfService": "उपयोग की शर्तें",
    "privacyPolicy": "गोपनीयता नीति",
    "guaranteeOfRights": "डेटा विषय के अधिकार",
    "customerSupport": "सहायता",
    "cookiePolicy": "कुकी नीति",
    "declarationOfSafety": "सिक्योरिटी・सुरक्षा घोषणा",
    "youthProtectionPolicy": "युवा सुरक्षा नीति",
    "communityPolicy": "सामुदायिक नीति",
    "probability": "probability",
    "operationPolicy": "संचालन नीति",
    "doNotSell": "मेरी व्यक्तिगत जानकारी न बेचें",
    "gameGrade": "",
    "communityPolicyView": "",
    "servicePolicy": "",
    "termsOfUse": "",
    "operationPolicyNCJ": "",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC 프라이버시 센터",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "NCSOFT 서비스 동의",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "गेमिंग कानूनों के बाद अतिरिक्त जानकारी",
    "brandInformation": "कंपनी के नाम की जानकारी",
    "copyright": "कॉपीराइट",
    "channelingInfo": "NCSOFT एक ब्रोकर है जो plaync के भीतर चैनलिंग गेम्स के ई-कॉमर्स में मध्यस्थता करता है, और उपर्युक्त सेल्स की सेल्स पार्टी नहीं है. <br>प्रदत्त चैनलिंग गेम्स से जुड़े सभी दायित्व और जिम्मेदारियां व्यक्तिगत ई-कॉमर्स पार्टी की हैं, और हम उनसे संबंधित मुद्दों के लिए ज़िम्मेदार नहीं हैं."
  },
  "infoCS": {
    "businessInformation": "व्यावसायिक जानकारी देखें",
    "infoAddress": "कंपनी का नाम: NCSOFT Corporation, Co-CEO: Kim Taek-Jin, Park Byung-Moo, व्यवसाय पंजीकरण संख्या: 144-85-04244, ई-कॉमर्स पंजीकरण: 2013-Gyeonggi Seongnam-1268",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "पता: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, कोरिया गणराज्य. ग्राहक सहायता: +82 1566-7004. फ़ैक्स: +82 02-2186-3499.",
    "pc": "",
    "other": "पता: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, कोरिया गणराज्य. ग्राहक सहायता: +82 1600-0020 (PC गेम), +82 1566-7004 (मोबाइल गेम). फ़ैक्स: +82 02-2186-3550 (PC गेम), +82 02-2186-3499 (मोबाइल गेम).",
    "none": "",
    "infoEmail": "ई-मेल",
    "infoEmail-mobile": "",
    "infoEmail-pc": "",
    "infoEmail-other": "",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "शीर्षक",
    "jpGenre": "शैली",
    "jpPrice": "कीमत",
    "jpPriceValue": "नि:शुल्क खेलें (इन-ऐप खरीदारी शामिल है)",
    "jpOs": "समर्थित OS",
    "jpDevelopedBy": "डेवलपर/प्रकाशक",
    "jpReleaseDay": "रिलीज़ की तारीख",
    "jpReleaseDayValue_LW": "04 नवंबर 2021"
  },
  "country": {
    "KR": "कोरिया गणराज्य",
    "TW": "ताइवान",
    "RU": "रूस",
    "MY": "मलेशिया",
    "SA": "सऊदी अरब",
    "SG": "सिंगापुर",
    "AE": "संयुक्त अरब अमीरात",
    "ID": "इंडोनेशिया",
    "JP": "जापान",
    "QA": "कतर",
    "TH": "थाईलैंड",
    "PH": "फिलिपींस",
    "HK": "हांगकांग",
    "UA": "यूक्रेन",
    "BY": "बेलारूस",
    "LT": "लिथुआनिया",
    "PL": "पोलैंड",
    "GR": "ग्रीस",
    "IL": "इज़राइल",
    "KW": "कुवैत",
    "AT": "ऑस्ट्रिया",
    "US": "अमेरिका",
    "CA": "कनाडा",
    "DE": "जर्मनी",
    "GB": "यूनाइटेड किंगडम",
    "FR": "फ्रांस",
    "BR": "ब्राज़ील",
    "IT": "इटली",
    "ES": "स्पेन",
    "CL": "चिली",
    "NO": "नॉर्वे",
    "SE": "स्वीडन",
    "IE": "आयरलैंड",
    "PT": "पुर्तगाल",
    "FI": "फिनलैंड",
    "DK": "डेनमार्क",
    "CH": "स्विट्ज़रलैंड",
    "AR": "अर्जेंटीना",
    "PE": "पेरू",
    "MX": "मेक्सिको",
    "KZ": "कज़ाखस्तान",
    "UZ": "उज़्बेकिस्तान",
    "AZ": "अज़रबैजान",
    "GE": "जॉर्जिया",
    "MD": "माल्डोवा",
    "AM": "आर्मीनिया",
    "MO": "मकाओ",
    "IN": "भारत",
    "PK": "पाकिस्तान",
    "NL": "नीदरलैंड",
    "RO": "रोमानिया",
    "AU": "ऑस्ट्रेलिया",
    "TR": "तुर्की",
    "EC": "इक्वाडोर",
    "CO": "कोलंबिया",
    "ZA": "दक्षिण अफ़्रीका",
    "EG": "मिस्र",
    "NC": "ग्लोबल"
  }
};

export default l10n;
